/**
 * Browser context detection utilities
 * Helps detect restricted environments like iframes where certain APIs are unavailable
 */

/**
 * Check if localStorage is available and accessible
 */
export function isLocalStorageAvailable(): boolean {
  try {
    const test = '__localStorage_test__';
    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Check if running inside an iframe
 */
export function isInIframe(): boolean {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}

/**
 * Check if in a restricted context where auth operations may fail
 * (e.g., iframe with storage restrictions)
 */
export function isRestrictedContext(): boolean {
  return isInIframe() || !isLocalStorageAvailable();
}

/**
 * Open current path in a new tab/window
 */
export function openInNewTab(path: string = window.location.pathname) {
  const url = `${window.location.origin}${path}`;
  window.open(url, '_blank');
}
